import type {CloseButtonProps} from '@chakra-ui/react';
import {useAlertStyles} from '@chakra-ui/react';
import {ChakraDiv} from '@linx-security/ui/utils/chakra-elements';
import type {FC} from 'react';

import {parts} from './theme/anatomy';

export const AlertContent: FC<CloseButtonProps> = props => {
  const {content} = useAlertStyles();
  return <ChakraDiv sx={content} {...props} {...parts.content.attrs} />;
};

export default AlertContent;
